export function setupLagermaterialCardHover() {
  document.querySelectorAll('.fischerstahl-lagermaterial-article-card').forEach(card => {
    const title = card.querySelector('.hover-title');
    if (!title) return;

    const originalText = title.dataset.originalText || title.textContent;

    card.addEventListener('mouseenter', () => {
      title.textContent = "Ansehen & konfigurieren";
    });

    card.addEventListener('mouseleave', () => {
      title.textContent = originalText;
    });
  });
}
